import { render, staticRenderFns } from "./AnimatedLoading.vue?vue&type=template&id=5f3e0a58&scoped=true&"
import script from "./AnimatedLoading.vue?vue&type=script&lang=js&"
export * from "./AnimatedLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e0a58",
  null
  
)

export default component.exports